export default __webpack_public_path__ + "static/media/consultation.3632579c.jpg";